// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","content":"App_content__wwONY","message":"App_message__j8rOT","title":"App_title__YS7Xx","link":"App_link__kpF6Q","imageWrapper":"App_imageWrapper__+vMD5"};